import { doGetCall } from "../config/rest";

function gethfData(page) {
    return doGetCall(`/wp-json/menus/v1/aggregated-hf-menu/${page}`);
}

export function fetchData(page) {
  return (dispatch) => {
    return gethfData(page)
      .then((json) => {
        dispatch(fetchDataSuccess(json));
        return json;
      })
      .catch((error) => dispatch(fetchDataFailure(error)));
  };
}


export const FETCH_DATA_BEGIN = "FETCH_Data_BEGIN";
export const FETCH_DATA_SUCCESS = "FETCH_Data_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_Data_FAILURE";

export const fetchDataBegin = () => ({
  type: FETCH_DATA_BEGIN,
});

export const fetchDataSuccess = (data) => ({
  type: FETCH_DATA_SUCCESS,
  payload: { data },
});

export const fetchDataFailure = (error) => ({
  type: FETCH_DATA_FAILURE,
  payload: { error },
});
